exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".process-title[data-v-a02100d2]{margin-bottom:36px}", "", {"version":3,"sources":["/opt/build/repo/src/modules/job-evaluation/components/process-option/process-option.vue"],"names":[],"mappings":"AACA,gCACC,kBAAoB,CACpB","file":"process-option.vue","sourcesContent":["\n.process-title[data-v-a02100d2] {\n\tmargin-bottom: 36px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a02100d2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/job-evaluation/components/process-option/process-option.vue
// module id = 2625
// module chunks = 74